module.exports = __webpack_public_path__ + "static/media/Onkar_Wagh.c16ecc94.jpg";